// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvarOperacionalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /franquias/salvarOperacional/{franquia_id}
 *
 * Partial-update endpoint for operational franchise configuration.
 * All fields are optional — the controller only persists keys that were
 * explicitly sent.
 */
import { registerContract } from './validate'

export interface Franquias_SalvarOperacionalInput {
capacidade_producao_diaria?: number
meta_producao_itens_dia?: number
valor_medio_item?: number
}

registerContract('Franquias_SalvarOperacionalInput', {
  capacidade_producao_diaria: { type: 'number',  required: false },
  meta_producao_itens_dia:    { type: 'number',  required: false },
  valor_medio_item:           { type: 'number',  required: false },
})
